import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Ciudad } from 'src/app/comun/models/ciudad';
import { Departamento } from 'src/app/comun/models/departamento';
import { ParametrosService } from 'src/app/services/parametros.service';
import { NeoDeptCiudadClienteHistorialDTO } from '../../Model/neoDeptCiudadClienteHistorialDTO';
import { CiudadClienteService } from '../../Service/ciudad-cliente.service';
import { DepartamentosClienteService } from '../../Service/departamentos-cliente.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { ModalService } from 'src/app/shared/service/modal.service';

declare var $: any;
@Component({
    selector: 'app-administracion-ubicaciones',
    templateUrl: './administracion-ubicaciones.component.html',
    styleUrls: ['./administracion-ubicaciones.component.scss'],
    standalone: false
})
export class AdministracionUbicacionesComponent implements OnInit {
  //idNeoCliente
  idNeoCliente: any;
  //Formulario filtro
  filtrosForm: UntypedFormGroup;
  //Lista de departamentos
  departamentos: Departamento[] = [];
  //Lista de ciudades
  ciudades: Ciudad[] = [];
  //Lista de historial de ubicaciones por idCliente
  ubicacionesIntermediario: NeoDeptCiudadClienteHistorialDTO[] = [];
  //Copia lista ubicacionesIntermediario
  ubicacionesIntermediarioCopia: NeoDeptCiudadClienteHistorialDTO[] = [];
  nombreArchivo: any;
  constructor(
    protected parametroService: ParametrosService,
    protected departamentosClienteService: DepartamentosClienteService,
    protected ciudadClienteService: CiudadClienteService,
    protected userIntermediarioService: UserService,
    private formBuilder: UntypedFormBuilder,
    private _sweetAlert: SweetAlertService,
    public _modal: ModalService
  ) { }

  ngOnInit(): void {
    this.getIdNeoCliente();
    this.getDepartamentos('169');
    this.crearFormularioFiltros();
    this.getUbicacionesIntermediario();
  }

  getIdNeoCliente(): any {
    this.idNeoCliente = this.userIntermediarioService.getUser().idCliente;
  }

  getDepartamentos(idPais: string) {
    this.parametroService.getDepartamentos(idPais).subscribe(
      (response) => {
        this.departamentos = response['data'];
      },
      (err) => {
        console.error(err);
      },
      () => {
        setTimeout(() => {
          $('#ciud').prop('disabled', true);
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );
  }

  getCiudades(idDepartamento: string) {
    this.parametroService.getCiudades(idDepartamento).subscribe(
      (response) => {
        this.ciudades = response['data'];
      },
      (err) => {
        console.error(err);
      },
      () => {
        setTimeout(() => {
          $('#ciud').prop('disabled', false);
          $('#ciud').selectpicker('refresh');
        });
      }
    );
  }
  crearFormularioFiltros() {
    this.filtrosForm = this.formBuilder.group({
      departamento: [''],
      ciudad: [''],
    });
  }

  getUbicacionesIntermediario() {
    if (this.idNeoCliente) {
      this.departamentosClienteService
        .getUbicacionesPorIdCliente(this.idNeoCliente)
        .subscribe(
          (data: any) => {
            if (data.exitoso) {
              this.ubicacionesIntermediario = data.departamentos;
              this.ubicacionesIntermediarioCopia = this.ubicacionesIntermediario;
            } else {
              this._sweetAlert.errorModal("¡Error!", false,
                'No se pudo obtener los lugares de atención del cliente.'
              );
            }
          },
          (err) => {
            console.error(err);
          }
        );
    }
  }
  comprobarValoresFormularioFiltro() {
    return (
      this.filtrosForm.controls.departamento.value ||
      this.filtrosForm.controls.ciudad.value
    );
  }

  resetearFormularioFiltro() {
    this.filtrosForm.reset();
    setTimeout(() => {
      $('#ciud').prop('disabled', true);
      $('.selectpicker').selectpicker('refresh');
    });
    this.ubicacionesIntermediario = this.ubicacionesIntermediarioCopia;
  }

  eliminarRegistroUbicacion(
    registroUbicacion: NeoDeptCiudadClienteHistorialDTO
  ) {
    if (registroUbicacion.aplicaTodasCiudades == 1) {
      this.departamentosClienteService
        .deleteDepartamentosCliente(registroUbicacion.idDepartamentoCliente)
        .subscribe(
          (data) => {
            this._sweetAlert.successModal("Éxito!", false,
              'Se ha eliminado el departamento de atencion'
            );
            this.getUbicacionesIntermediario();
          },
          (err) => {
            console.error(err);
          }
        );
    } else {
      this.ciudadClienteService
        .deleteCiudadCliente(registroUbicacion.idCiudadCliente)
        .subscribe(
          (data) => {
            this._sweetAlert.successModal("Éxito!", false,
              'Se ha eliminado la ciudad de atencion'
            );
            this.getUbicacionesIntermediario();
          },
          (err) => {
            console.error(err);
          }
        );
    }
  }

  filtrarLista() {
    if (
      this.filtrosForm.controls.departamento.value &&
      !this.filtrosForm.controls.ciudad.value
    ) {
      const departamentos = this.ubicacionesIntermediarioCopia.filter(
        (registro) => {
          return (
            +registro.idDepartamento ===
            +this.filtrosForm.controls.departamento.value
          );
        }
      );
      this.ubicacionesIntermediario = departamentos;
    } else if (
      this.filtrosForm.controls.departamento.value &&
      this.filtrosForm.controls.ciudad.value
    ) {
      const departamentos = this.ubicacionesIntermediarioCopia.filter(
        (registro) => {
          return (
            +registro.idDepartamento ===
            +this.filtrosForm.controls.departamento.value
          );
        }
      );
      const ciudades = departamentos.filter((registro) => {
        return +registro.idCiudad === +this.filtrosForm.controls.ciudad.value;
      });
      this.ubicacionesIntermediario = ciudades;
    }
  }

  capturarFile(event: any) {
    if (/xls/i.test(event.target.files[0].name) || /txt/i.test(event.target.files[0].name)) {
      this.nombreArchivo = event.target.files[0].name;
      this.extraerBase64(event.target.files[0]).then((file: any) => {
        let json = {
          extension: this.nombreArchivo.split('.', 2)[1],
          idCliente_NeoCliente: +this.idNeoCliente,
          archivo: file.base.split(',')[1],
        }
        this.departamentosClienteService.cargarArchivo(json).subscribe((resp: any) => {
          if (resp.exitoso) {
            if (resp.errores?.length > 0) {
              this._sweetAlert.infoModal("Se encontraron los siguientes errores", false, resp.errores).then((result) => {
                if (result.isConfirmed) {
                  this._sweetAlert.successModal("¡Éxito!", false,
                    'Los demás lugares de atención se han creado exitosamente.'
                  );
                }
              });
            } else {
              this._sweetAlert.successModal("¡Éxito!", false,
                'Se han creado los lugares de atención exitosamente.'
              );
            }
          } else {
            this._sweetAlert.errorModal('Se ha presentado un error al momento de crear los lugares de atención.');
          }
        });
      });
    } else {
      this._sweetAlert.infoModal('Solo formato xls y txt.', false);
    }
  }

  extraerBase64 = async ($event: any) =>
    new Promise((resolve) => {
      try {
        const reader = new FileReader();
        reader.readAsDataURL($event);
        reader.onload = () => {
          resolve({
            base: reader.result,
          });
        };
        reader.onerror = (error) => {
          resolve({
            base: null,
          });
        };
      } catch (e) {
        return null;
      }
    });

  getNombreDepartamento(idDepartamento: number): string {
    const dep = this.departamentos.find(d => d.idDepartamento === idDepartamento);
    return dep ? dep.nombreDepartamento.toUpperCase() : '';
  }
}
